import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import Reveal from "@/components/Reveal";

export default function CTASection() {
  return (
    <section className="bg-graphite relative overflow-hidden">
      <div className="absolute inset-0 grid-lines opacity-40" aria-hidden="true" />
      <div className="container-x relative py-16 sm:py-24 lg:py-28">
        <div className="max-w-3xl">
          <Reveal>
            <p className="text-xs font-semibold uppercase tracking-[0.2em] text-techblue">
              Fale com um especialista
            </p>
          </Reveal>
          <Reveal delay={0.08}>
            <h2 className="mt-4 text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-white leading-tight">
              Pronto para elevar o padrão da sua infraestrutura de TI?
            </h2>
          </Reveal>
          <Reveal delay={0.14}>
            <p className="mt-4 text-base lg:text-lg text-white/70 leading-relaxed max-w-2xl">
              Solicite uma avaliação técnica. Analisamos o cenário atual da sua operação e
              apresentamos um plano de ação claro, sem compromisso.
            </p>
          </Reveal>
          <Reveal delay={0.2}>
            <div className="mt-8 flex flex-col sm:flex-row gap-3">
              <Link
                to="/contato"
                data-testid="cta-banner-assessment"
                className="inline-flex items-center justify-center gap-1.5 bg-techblue hover:bg-techblue-hover text-white text-sm font-semibold px-7 py-3.5 rounded-md transition-colors duration-200"
              >
                Solicitar avaliação técnica
                <ArrowUpRight className="w-4 h-4" />
              </Link>
              <Link
                to="/servicos"
                data-testid="cta-banner-solutions"
                className="inline-flex items-center justify-center gap-1.5 border border-white/25 hover:border-techblue hover:text-techblue text-white text-sm font-semibold px-7 py-3.5 rounded-md transition-colors duration-200"
              >
                Conhecer soluções
              </Link>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
